import { render, staticRenderFns } from "./rcc-dialog-button.vue?vue&type=template&id=828da1f6&"
import script from "./rcc-dialog-button.vue?vue&type=script&lang=js&"
export * from "./rcc-dialog-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports